import http from "./http-commons";

class InscripcionesService {
  async ObtenerMateriasCursado() {
    try {
      const result = await http.get("/api/v3/materias-disponibles", {
        headers: { Authorization: `Token ${sessionStorage.getItem("token")}` },
      });
      return result.data.materias;
    } catch (error) {
      console.log("error" + error);
      return error;
    }
  }

  async ObtenerMateriasCursando() {
    try {
      const result = await http.get("/api/v3/materias-cursando", {
        headers: { Authorization: `Token ${sessionStorage.getItem("token")}` },
      });
      return result.data.materias;
    } catch (error) {
      console.log("error" + error);
      return error;
    }
  }

  async InscribirMateria(id) {
    var info = { materia: id };
    try {
      const result = await http.post("/api/v3/inscribir-materia", info, {
        headers: { Authorization: `Token ${sessionStorage.getItem("token")}` },
      });
      return result.data.error;
    } catch (error) {
      console.log("error" + error);
      return error;
    }
  }

  async ObtenerMateriasExamen() {
    try {
      const result = await http.get("/api/v3/finales-disponibles", {
        headers: { Authorization: `Token ${sessionStorage.getItem("token")}` },
      });
      return result.data.mesas;
    } catch (error) {
      console.log("error" + error);
      return error;
    }
  }

  async InscribirFinal(id, promocionado, mejorar_nota, division) {
    var info = {
      id: id,
      promovido: promocionado,
      mejora_nota: mejorar_nota,
      division: division,
    };
    // console.log(info)
    try {
      const result = await http.post("/api/v3/inscribir-examen-final", info, {
        headers: { Authorization: `Token ${sessionStorage.getItem("token")}` },
      });
      return result.data.error;
    } catch (error) {
      console.log("error" + JSON.stringify(error));
      return error;
    }
  }

  async ObtenerInscripcionesExamenes() {
    try {
      const result = await http.get("/api/v3/finales-inscriptos", {
        headers: { Authorization: `Token ${sessionStorage.getItem("token")}` },
      });
      return result.data.mesas;
    } catch (error) {
      console.log("error" + error);
      return error;
    }
  }

  async EliminarFinal(id) {
    var info = { id: id };
    try {
      const result = await http.post(
        "/api/v3/desinscribir-examen-final",
        info,
        {
          headers: {
            Authorization: `Token ${sessionStorage.getItem("token")}`,
          },
        },
      );
      return result.data.error;
    } catch (error) {
      console.log("error" + error);
      return error;
    }
  }

  async ObtenerCarrerasCompletas(){
    try {
      const result = await http.get(
        "/api/v3/inscripcion-carreras-abiertas",
        {
          headers: {
            Authorization: `Token ${sessionStorage.getItem("token")}`,
          },
        },
      );
      return result.data;
    } catch (error) {
      console.log("error" + error);
      return error;
    }
  }

  async ObtenerCarreras() {
    try {
      const result = await http.get(
        "api/v3/inscripcion-carreras-abiertas-autogestion",
        {
          headers: {
            Authorization: `Token ${sessionStorage.getItem("token")}`,
          },
        },
      );
      return result.data.data;
    } catch (error) {
      console.log("error" + error);
      return error;
    }
  }

  async ObtenerPreinscripcionesRealizadas(){
    try {
      const result = await http.get(
        "api/v3/inscripcion-carreras-abiertas-autogestion",
        {
          headers: {
            Authorization: `Token ${sessionStorage.getItem("token")}`,
          },
        },
      );
      return result.data.data;
    } catch (error) {
      console.log("error" + error);
      return error;
    }
  }

  async SaveAlumnoPreinscripcion(carreras) {
    try {
      const info = { carreras: carreras };
      const result = await http.post(
        "api/v3/send-preinscripto-autogestion",
        info,
        {
          headers: {
            Authorization: `Token ${sessionStorage.getItem("token")}`,
          },
        },
      );
      return result;
      // tendriamos que solamente llamar a /api/v3/send-preinscripto y que ahi se consuma toda la informacion
    } catch (error) {
      //si fallo el segundo o el tercero, que haga un delete del 1ro
      return error;
    }
  }

  async ObtenerRematriculacionesAbiertas() {
    try {
      const result = await http.get(
        "api/v3/periodos-rematriculacion-abiertos",
        {
          headers: {
            Authorization: `Token ${sessionStorage.getItem("token")}`,
          },
        },
      );
      return result.data;
    } catch (error) {
      console.log("error" + error);
      return error;
    }
  }

}

// eslint-disable-next-line import/no-anonymous-default-export
export default new InscripcionesService();
